import React from 'react';
import TextField, {HelperText, Input} from '@material/react-text-field';
import '@material/react-text-field/dist/text-field.css';
import { Button } from 'react-bootstrap';

function ContactUs() {
    return (
        <div className="s-contact">
            <div className="parallax-contact">
                <div className="container-fluid" style={{opacity:'1 !important'}}>
                    <div className="row pt-6">
                        <div className="col-sm-12">
                            <h5 className="center green-text text-darken-1">CONTACT US</h5>
                        </div>
                        <div className="col-sm-12 pt-4 ">
                            <h1 className="center white-text" style={{fontSize: '3.8rem'}}>
                                Reach out for a new project or just <br/> say hello
                            </h1>
                        </div>
                        <div className="col-sm-12 col-md-6 offset-md-3">
                            <div className="pt-4 mt-4" style={{borderBottom: '1px solid #d3d3d3'}}></div>
                        </div>
                    </div>
                </div>

                <div className="container pt-5">
                    <div className="row">
                        <div className="col-sm-12 col-md-7" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
                            <div className="row mt-4 pl-5">
                                <div className="col-sm-12">
                                    <h6 className="white-text pt-4 mt-4 ff-mono bold ">SEND US A MESSAGE</h6>
                                </div>
                                <div className="col-sm-12">
                                    <TextField
                                        style={{backgroundColor: 'transparent', borderBottom: '1px solid #454545'}}
                                        className="w-100 mt-4"
                                        lineRippleClassName="green darken-2"
                                        floatingLabelClassName="green-text text-darken-2 ff-mono"
                                        label='Your Name'>
                                        <Input onChange={(e) => console.log(e.currentTarget.value)} />
                                    </TextField>
                                </div>
                                <div className="col-sm-12">
                                    <TextField
                                        className="w-100 mt-4"
                                        style={{backgroundColor: 'transparent', borderBottom: '1px solid #454545'}}
                                        lineRippleClassName="green darken-2"
                                        floatingLabelClassName="green-text text-darken-2 ff-mono"
                                        label='Your Email'>
                                        <Input onChange={(e) => console.log(e.currentTarget.value)} />
                                    </TextField>
                                </div>
                                <div className="col-sm-12">
                                    <TextField
                                        className="w-100 mt-4"
                                        style={{backgroundColor: 'transparent', borderBottom: '1px solid #454545'}}
                                        lineRippleClassName="green darken-2"
                                        floatingLabelClassName="green-text text-darken-2 ff-mono"
                                        label='Subject'>
                                        <Input onChange={(e) => console.log(e.currentTarget.value)} />
                                    </TextField>
                                </div>
                                <div className="col-sm-12">
                                    <TextField
                                        className="w-100 mt-4"
                                        style={{backgroundColor: 'transparent', borderBottom: '1px solid #454545', height: 150}}
                                        lineRippleClassName="green darken-2"
                                        floatingLabelClassName="green-text text-darken-2 ff-mono"
                                        outlined={false}
                                        label='Message'>
                                        <Input onChange={(e) => console.log(e.currentTarget.value)} />
                                    </TextField>
                                </div>
                                <div className="col-sm-12">
                                    <div className="green mt-4 center p-3"><span className="ff-mono bold white-text" style={{letterSpacing: 3}}>SUBMIT</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-5 pl-5 pt-4 " style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
                            <h6 className="white-text pt-4 mt-4 ff-mono bold">CONTACT INFO</h6>
                            <h6 className="green-text pt-4 mt-4 ff-mono">Where to Find Us</h6>
                            <h6 className="grey-text pt-4" >
                                Sharjha al nadha, continental building 702 flat, Dubai - United Arab Emirates
                            </h6>
                            <h6 className="green-text pt-4 mt-4 ff-mono">Email Us At</h6>
                            <h6 className="grey-text pt-4 ">
                                info.karotservingit@gmail.com<br/>aibak.butt113@gmail.com
                            </h6>
                            <h6 className="green-text pt-4 mt-4 ff-mono">Call Us At</h6>
                            <h6 className="grey-text pt-4 ">
                                Phone1: (+92) 305 4876104
                                Phone2: (+92) 306 7043716
                                Phone3: (+92) 313 0012886
                            </h6>
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h1 className="white-text f-lg bold">Karot<span className="f-xxl green-text bold">.</span></h1>
                        <p className="mt-4" style={{lineHeight: 2}}>Proin eget tortor risus. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Praesent sapien massa, convallis a pellentesque nec, egestas non nisi. Mauris blandit aliquet elit, eget tincidunt nibh pulvinar a. Nulla porttitor accumsan tincidunt. Nulla porttitor accumsan tincidunt. Quaerat voluptas autem necessitatibus vitae aut.</p>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <h5 className="white-text">Get Notified</h5>
                        <p className="mt-4 pt-3" style={{lineHeight: 2}}>Quia quo qui sed odit. Quaerat voluptas autem necessitatibus vitae aut non alias sed quia. Ut itaque enim optio ut excepturi deserunt iusto porro.</p>
                    </div>
                </div>
                </div>

                <div className="row">

                </div>
            </div>
            
        </div>
    )
}

export default ContactUs;